// extracted by mini-css-extract-plugin
export var avatar = "_pd-3";
export var avatarContainer = "_pd-2";
export var avatarSpacer = "_pd-5";
export var avatarSpacerContainer = "_pd-4";
export var avatarStackContainer = "_pd-1";
export var bubble = "_pd-0";
export var remainderBubble = "_pd-6";